export const HOME = 1;
export const GUILDS = 2;
export const MESSAGES = 3;
